module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.3984/img/callout-wave.svg"